var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface essential/Zap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.6045 3.50708L6.15445 13.0571C5.94796 13.4103 5.94856 13.8476 6.15601 14.2003C6.36347 14.553 6.74538 14.7659 7.15445 14.7571H10.0145C10.3822 14.7544 10.7358 14.8986 10.9967 15.1577C11.2577 15.4168 11.4045 15.7693 11.4045 16.1371V19.7471C11.4078 20.1856 11.6966 20.5708 12.1166 20.697C12.5366 20.8233 12.9899 20.6611 13.2345 20.2971L18.5145 12.3771C18.7455 12.0286 18.7673 11.5816 18.5712 11.2123C18.3751 10.8431 17.9926 10.6108 17.5745 10.6071H14.8545C14.0923 10.6071 13.4745 9.98924 13.4745 9.22708V4.00708C13.4776 3.55169 13.1727 3.15166 12.7328 3.03403C12.2928 2.9164 11.829 3.11087 11.6045 3.50708Z",
    fill: "#3FDD78"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/zap.e76c0a4c2a4c181a92f52d748f383503.svg";
export { ForwardRef as ReactComponent };